import { render } from "./entity_form.html?vue&type=template&id=3f72d4c0&scoped=true&external"
import script from "./entity_form.js?vue&type=script&lang=js&external"
export * from "./entity_form.js?vue&type=script&lang=js&external"

import "./EntityForm.vue?vue&type=style&index=0&id=3f72d4c0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f72d4c0"]])

export default __exports__